module.exports = __webpack_public_path__ + "static/IMG_3029-dbab6f0cf49e90ff0344df688b1dcca8.jpg";